export default __webpack_public_path__ + "static/media/start_today.598ee9a5.png";